import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import moment from "moment";

import {Table, Pagination} from 'antd';
import {BigLoading} from "../../components/BigLoading";
import SearchForm from "./SearchForm/SearchForm";

import {getRequestList} from "../../store/request-list/actions";
import {clearRequestDetails, getRequestDetails} from "../../store/request-details/actions";
import {setFilterData} from "../../store/filters/actions";

import {routePath} from "../../router/paths";
import {notaryRequestTypeVocabulary, statusCodesVocabulary, translate} from "../../utils/utils";
import {DATETIME_FORMAT_FULL} from "../../utils/constants";

const RequestList = (props) => {
  const dispatch = useDispatch();

  const requestList = useSelector((state) => state.requestList)
  const requestDetails = useSelector((state) => state.requestDetails)
  const user = useSelector((state) => state.user);
  const filters = useSelector((state) => state.filtersData);

  // useEffect(()=>{
  //   dispatch(getRequestList( filters.data, filters.page, filters.size));
  // },[]);

  useEffect(() => {
    dispatch(getRequestList(filters.data, filters.page, filters.size));
  }, [filters]);

  useEffect(()=> {
    if(requestDetails && requestDetails.payload && requestDetails.payload.data && requestDetails.payload.data.notaryRequestInfo){
      props.history.push({
        pathname: routePath.REQUEST_DETAILS,
        state: {backPath: props.history.location.pathname}
      })
    }
  },[requestDetails]);


  const columns = [
    {
      title: 'Дата і час створення Запиту',
      dataIndex: 'createDateTime',
      // className: 'column-name',
      key: '0',
      render:(value)=>value && moment(value).parseZone().format(DATETIME_FORMAT_FULL)
    },
    {
      title: 'Вхідний Номер Запиту',
      dataIndex: 'regNumberIn',
      // className: 'column-name',
      key: '1',
    },
    {
      title: 'Номер відповіді',
      dataIndex: 'regNumberOut',
      // className: 'column-name',
      key: '2',
    },
    {
      title: 'Дата відповіді',
      dataIndex: 'regDateOut',
      // className: 'column-name',
      key: '234',
      render:(value)=> value  && moment(value).parseZone().format(DATETIME_FORMAT_FULL)
    },
    {
      title: 'ПІБ вкладника',
      dataIndex: 'notaryRequestInfo',
      // className: 'column-name',
      key: '3',
      render: (data)=> `${data.lastName|| "" } ${data.firstName|| ""} ${data.middleName|| ""}`
    },
    {
      title: 'Паспортні дані (за наявності)',
      dataIndex: 'notaryRequestInfo',
      // className: 'column-passport',
      key: '4',
      render: (data)=>`${data.passportSerial || ""} ${data.passportNumber||""}`
    },
    {
      title: 'Реєстраційний номер облікової картки платника податків',
      dataIndex: 'notaryRequestInfo',
      // className: 'column-ipn',
      key: '5',
      render: (data)=> data.ipn
    },
    {
      title: 'Тип запиту',
      dataIndex: 'subRequestType',
      // className: 'column-ipn',
      key: '6',
      render: (code) => translate(notaryRequestTypeVocabulary, code)
    },

    {
      title: 'Статус заявки',
      dataIndex: 'portalStatusName',
      // className: 'column-ipn',
      key: '7',
      render: (code) => translate(statusCodesVocabulary, code)
    },
  ];

  const paginationHandler = (pageNumber, pageSize) => {
    dispatch( setFilterData(filters.data, pageNumber, pageSize))
  };

  return (
    <div className="request-list-container">
      <SearchForm/>
      {(requestList.isFetching || requestDetails.isFetching) && <BigLoading/>}
      <div>
        <Table
          rowKey={(record)=> record.id}
          columns={columns}
          pagination={false}
          className="request-list-table"
          dataSource={requestList && requestList.payload &&  requestList.payload.data && requestList.payload.data.processesList}
          rowClassName={(record, index)=>"row"}
          onRow={(record, rowIndex) => {
            console.log("record", record)
            return {
              onClick: event => {
                dispatch(getRequestDetails(record.requestId));
              },
            };
          }}
        />

        <Pagination defaultCurrent={1}
                    total={requestList && requestList.payload &&  requestList.payload.data && requestList.payload.data.count}
                    showSizeChanger={true}
                    onChange={paginationHandler}
                    onShowSizeChange={paginationHandler}
                    style={{marginBottom: "1rem"}}
        />
      </div>
      {/*{console.log("pagination", requestList && requestList.payload &&  requestList.payload.data && requestList.payload.data.numberOfElements)}*/}

    </div>
  );
};

export default RequestList;